import styled from 'styled-components';
import {getSpacing} from '@tickchak/react-share/app';
import {dFlexColumn} from '../../../globalVariables/GlobalFlex';

export const userBubble = styled.div`
    align-self: flex-end;
    padding: var(--space-xs) var(--space-lg);
    border-radius: 100px;
    background: var(--color-bg-surface-default);
    color: var(--color-text-default);
    white-space: pre-line;
    max-width: 100%;
`;

export const aiCard = styled.div`
    align-self: flex-start;
    ${dFlexColumn}
    gap: ${getSpacing('spaceSm')};
    max-width: 273px;
    width: 100%;
    padding: ${getSpacing('spaceLg')};
    border-radius: var(--border-radius-border-radius-2xl);
    background: var(--color-brand-subtle);
`;

export const aiCardIntro = styled.p`
    margin: 0;
    font-size: var(--font-size-body, 16px);
    font-weight: var(--font-weight-regular, 400);
    line-height: 1.4;
    color: var(--color-text-default);
    text-align: start;
    white-space: pre-wrap;
`;

export const aiCardBody = styled.div`
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-regular);
    line-height: 1.4;
    color: var(--color-text-default);
    text-align: right;
    white-space: pre-wrap;
    word-break: break-word;

    strong {
        font-weight: var(--font-weight-bold);
    }

    em {
        font-style: italic;
    }
`;

export const aiCardDivider = styled.hr`
    width: 100%;
    margin: 0;
    border: none;
    border-top: 1px solid var(--color-border-subtle);
`;

export const aiCardActions = styled.div`
    width: 100%;

    button {
        width: 100%;
    }
`;
